import React from "react";
import { Link } from "react-router-dom";

const BreadCrumbOne = ({ title, page, subtitle }) => {
  const isTitle = "Cookie Policy";
  const isCookiePolicy = isTitle.includes(title);
  return (
    <div
      className="breadcrum-area"
      style={
        isCookiePolicy
          ? { padding: "200px 0 20px" }
          : { padding: "200px 0 70px" }
      }
    >
      <style>
        {`
        @media (max-width: 767px) {
          .breadcrum-area {
            padding: ${
              isCookiePolicy ? "100px 0 20px" : "100px 0 40px"
            } !important;
          }
        }
      `}
        {`
         @media (max-width: 1024px) {
          .breadcrum-area {
            padding: ${isCookiePolicy ? "100px 0 40px" : "100px 0 60px"} !important;
            }
          }
        `}
        {`
         @media (max-width: 1198px) {
          .breadcrum-area {
            padding: ${isCookiePolicy ? "100px 0 20px" : "140px 0 60px"} !important;
            }
          }
        `}
         {`
        @media (min-width: 1199px) and (max-width: 1280px) {
            .breadcrum-area {
              padding: ${
                isCookiePolicy ? "100px 0 20px" : "200px 0 60px"
              } !important;
            }
          }
        `}
      </style>
      <div className="container">
        <div className="breadcrumb">
          <ul className="list-unstyled">
            <li>
              <Link
                to={process.env.PUBLIC_URL + "/"}
                style={{ color: "var(--color-text-dark)" }}
              >
                Home
              </Link>
            </li>
            <li
              className="active"
              dangerouslySetInnerHTML={{ __html: page }}
            ></li>
          </ul>
          <h1
            className="title h2"
            dangerouslySetInnerHTML={{ __html: title }}
            style={{
              color: "var(--color-text-dark)",
            }}
          ></h1>
          <span
            className="subtitle-5"
            style={{ color: "var(--color-text-dark)" }}
          >
            {subtitle}{" "}
          </span>
        </div>
      </div>

      {/* <ul className="shape-group-8 list-unstyled">
                <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/bubble-9.png"} alt="Bubble" /></li>
                <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/bubble-11.png"} alt="Bubble" /></li>
                <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/line-4.png"} alt="Line" /></li>
            </ul> */}
    </div>
  );
};

export default BreadCrumbOne;
